// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-management-permissions[data-v-92d6b0a0] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
.project-management-permissions[data-v-92d6b0a0] .left-right-box .right {
  display: flex;
  height: 100%;
  gap: 10px;
}
.project-management-permissions[data-v-92d6b0a0] .left-right-box .right > div {
  flex: 1;
}
.top[data-v-92d6b0a0] {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
.top .topLeft[data-v-92d6b0a0] {
  flex: 1;
}
.top .topRight[data-v-92d6b0a0] {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/SystemManagement/ProjectManagementPermissions/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;ACAF;ADPA;EAUM,aAAA;EACA,YAAA;EACA,SAAA;ACAN;ADZA;EAcQ,OAAA;ACCR;ADIA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;ACFF;ADHA;EAOI,OAAA;ACDJ;ADNA;EAUI,OAAA;ACDJ","sourcesContent":["\n.project-management-permissions {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n  ::v-deep .left-right-box {\n    .right {\n      display: flex;\n      height: 100%;\n      gap: 10px;\n      > div {\n        flex: 1;\n      }\n    }\n  }\n}\n.top {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  .topLeft {\n    flex: 1;\n  }\n  .topRight {\n    flex: 1;\n  }\n}\n",".project-management-permissions {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n}\n.project-management-permissions ::v-deep .left-right-box .right {\n  display: flex;\n  height: 100%;\n  gap: 10px;\n}\n.project-management-permissions ::v-deep .left-right-box .right > div {\n  flex: 1;\n}\n.top {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n}\n.top .topLeft {\n  flex: 1;\n}\n.top .topRight {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
